import React from "react";
import Overlay from 'react-bootstrap/Overlay';
import Clipboard from 'react-clipboard.js';
import Helper from "../functions/Helper.js";

const defaultPopoverStyle={
  backgroundColor: '#000000',
  fontWeight:"600",
  color:"white",
  boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)',
  border: '1px solid #CCC',
  borderRadius: 3,
  marginLeft: -5,
  marginTop: 5,
  padding: 10,
  fontSize:14,
};

function SavedPopover({ style }) {
  return (
    <div
      style={{
        ...defaultPopoverStyle,
        ...style,
      }}
    >
      <strong>Saved to Clipboard!</strong> <br/> Apply at Checkout for Discount.
    </div>
  );
}

function HoverPopover({ style }) {
  return (
    <div
      style={{
        ...defaultPopoverStyle,
        ...style,
      }}
    >
      Copy Coupon Code
    </div>
  );
}


export default class CouponCode extends React.Component{

  constructor(props){
    super(props);
    this.state={showHover:false,showSaved:false};
  }

  trackEvent(value){
    Helper.gaEvent('event', "Clipboard" , value ? "saved" : "error", this.props.code + " - " + this.props.name);
  }

  render(){
    return(
      <div style={this.props.style}>
        <div  ref={(div)=>this.div=div}
          onMouseEnter={()=>{this.setState({showHover:true})}}
          onMouseLeave={()=>{this.setState({showHover:false})}}
          onClick={()=>{setTimeout(()=>{this.setState({showSaved:false})},3000);this.setState({showSaved:true,showHover:false})}}>

          <Clipboard onError={()=>{this.trackEvent(false)}} onSuccess={()=>{this.trackEvent(true)}} component="span" data-clipboard-text={this.props.code}>
            {this.props.type==="table" ?
            <span style={{whiteSpace:"nowrap"}}>
              Code <span style={{fontWeight:"bold",color:"rgb(39, 128, 227)",cursor:"pointer"}}>{" " +this.props.code}</span>
            <br/>
              <span style={{fontSize:14}}>
                Get {this.props.discount_name}
              </span>
            </span>
            :
            <span style={{cursor:"pointer",whiteSpace:"nowrap"}}>
              Use Code {" " +this.props.code}
            </span> }
          </Clipboard>

        </div>
        <Overlay onHide={()=>{}} show={this.state.showSaved} placement="bottom" target={this.div} animation={false} rootClose={true}>
          <div>
            <SavedPopover style={this.props.PopoverStyle}/>
          </div>
        </Overlay>

        <Overlay show={this.state.showHover && !this.state.showSaved} onHide={() => {this.setState({ showHover: false })}} placement="bottom" animation={false} target={this.div} >
          <div>
            <HoverPopover style={this.props.PopoverStyle} />
          </div>
        </Overlay>
      </div>
    );
  }
}
